/*
 * UMM shared multi-item add-to-cart (Oct 2026).
 * Used by the Discover Your Ritual consultation, the product page
 * "Complete the Ritual" pairing and the Your Ritual Continues page.
 * Follows the same cart-drawer flow as umm-build-your-ritual.js.
 */
(function () {
  if (window.UMMRitualCart) return;

  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async function add(items, opener) {
    items = (items || []).filter(function (i) { return i && i.id; }).map(function (i) {
      return { id: parseInt(i.id, 10), quantity: parseInt(i.quantity || 1, 10) };
    });
    if (!items.length) return { ok: false, message: 'Nothing to add.' };

    var cart = cartEl();
    var sectionIds = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    try {
      var res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds, sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (data.status) {
        return { ok: false, message: data.description || data.message || 'Something went wrong. Please try again.' };
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'umm-ritual-cart' });
      }
      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
        if (cart.tagName === 'CART-DRAWER' && !cart.className.includes('open-after-adding') && typeof cart.open === 'function') {
          cart.open(opener);
        }
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
      return { ok: true };
    } catch (e) {
      console.error('UMMRitualCart: add failed', e);
      return { ok: false, message: 'Something went wrong. Please try again.' };
    }
  }

  async function setAttributes(attributes) {
    try {
      await fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    } catch (e) { /* attribution is best effort */ }
  }

  function track(name, detail) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, detail || {});
      }
    } catch (e) { /* analytics is best effort */ }
  }

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Any button with data-umm-add="variantId,variantId" adds those variants. */
  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-umm-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    var ids = (btn.getAttribute('data-umm-add') || '').split(',').filter(Boolean);
    var label = btn.querySelector('[data-umm-add-label]') || btn;
    var original = label.textContent;
    var scope = btn.closest('[data-umm-add-scope]') || btn.parentElement;
    var status = scope && scope.querySelector('[data-umm-add-status]');
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding';
    var result = await add(ids.map(function (id) { return { id: id, quantity: 1 }; }), btn);
    btn.removeAttribute('aria-busy');
    label.textContent = result.ok ? 'Added' : original;
    if (status) { status.textContent = result.ok ? '' : result.message; status.hidden = result.ok; }
    if (result.ok) {
      track('umm_ritual_add', { source: btn.getAttribute('data-umm-source') || '', variants: ids });
      setTimeout(function () { label.textContent = original; }, 2500);
    }
  });

  window.UMMRitualCart = { add: add, setAttributes: setAttributes, track: track, money: money };
})();
